import { dataUserLabelSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserLabelSolid = /*#__PURE__*/createIcon(dataUserLabelSolid)
export default IconUserLabelSolid
